<template>
  <div class="home">
    <div class="container">
      <h1 class="h2 mt-5 mb-4">Choose the game</h1>
      <div class="row">
        <div class="col-4" v-for="game in games" v-bind:key="game">
          <router-link :to="`/${game}`" class="card card--selectable">
            <div class="card-body">
              <h1 class="h3 text-dark">{{ game | cap }}</h1>
              <img src="/img/board.png" :alt="`${game} board`" class="img-fluid">
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

// @ is an alias to /src
export default {
  name: 'home',
  created() {
    const game = this.$localStorage.get('gameSlug') || 'tafl';
    this.$router.push(`/${game}`);
  },
  data() {
    return {
      games: config.games,
    };
  },
};
</script>
